<template>
  <form class="modal-dialog">
    <div class="modal-content b-shadow">
      <div class="modal-header">
        <h5 class="modal-title">Przypomnienie hasła</h5>
      </div>
      <div class="modal-body">
        <div v-if="alert" class="alert alert-info">
          <p>
            Wysłano przypomnienie hasła na adres
            <i>{{form.email.value}}</i>.
          </p>
        </div>
        <router-link :to="{name: 'mainPage'}" v-if="alert">&larr; powrót do logowania</router-link>
        <div v-if="!submitted" class="form-group">
          <label class="required">Email</label>
          <input
            id="email"
            name="email"
            class="form-control"
            type="email"
            required
            v-model="form.email.value"
            @blur="validateField($event, form.email)"
          />
          <span class="invalid-feedback" v-if="form.email.errors.required">Email nie może być pusty</span>
        </div>
      </div>
      <div class="modal-footer">
        <button
          v-if="!submitted"
          class="btn btn-primary"
          :disabled="!submittable"
          @click="submit"
        >Wyślij</button>
      </div>
    </div>
  </form>
</template>

<script>
import Form from "redbay-b2b-form/src/Form";

export default {
  components: {},
  data() {
    return {
      alert: false,
      form: Form.build({ email: "" }),
      submitted: false,
      progress: false
    };
  },
  computed: {
    submittable() {
      return !this.progress && !this.submitted;
    }
  },
  methods: {
    ...Form.methods(),
    async submit(evt) {
      let dataForm = this.validateForm(evt, this.form);
      evt.preventDefault();
      if (dataForm) {
        try {
          this.progress = true;
          await this.$store.dispatch("user/restorePassword", dataForm);
          this.progress = false;
          this.submitted = true;
          this.alert = true;
        } catch (e) {
          this.setCustomError(this.form.email);
          this.progress = false;
          this.submitted = false;
          console.log(e);
        }
      }
    }
  },
  async beforeMount() {
    let auth = await this.$store.dispatch("user/isAuthorized");
    if (auth) {
      this.$router.replace({ name: "searchPage" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/user/src/RestorePasswordPage.vue